import React from 'react';
import TogglePanel from '../components/TogglePanel';

interface NotificationsPageProps {
  accessToken?: string;
}

function NotificationsPage({ accessToken }: NotificationsPageProps) {
  return (
    <div className="user-preferences-content">
      <div className="page-header-section">
        <h1 className="page-header">Notifications</h1>
        <p className="page-description">Customize how Lore communicates with you.</p>
      </div>
      <div className="page-content-section">
        <TogglePanel 
          label="Email"
          defaultChecked={false}
          onChange={(checked) => console.log('Email notifications:', checked)}
        />
        <TogglePanel 
          label="Push notifications "
          defaultChecked={false}
          onChange={(checked) => console.log('Push notifications:', checked)}
        />
      </div>
    </div>
  );
}

export default NotificationsPage;